class AppConstants {
    static JWT = "JWT";
}
export default AppConstants;
